import { render, staticRenderFns } from "./playlists-grid-block.vue?vue&type=template&id=7ebe8a6f"
import script from "./playlists-grid-block.vue?vue&type=script&lang=js"
export * from "./playlists-grid-block.vue?vue&type=script&lang=js"
import style0 from "./playlists-grid-block.vue?vue&type=style&index=0&id=7ebe8a6f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports